import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { resolvePadding } from '../utils/padding.js';
import { wrapVar, fill, row, col, spacer } from './stack.css.js';

/**
 * Set up a flex container set to `flex-direction: row`.
 *
 * @compose { "root": true }
 */
const Row = stack(row);
Row.displayName = 'Stack.Row';
/**
 * Set up a flex container set to `flex-direction: column`.
 *
 * @compose { "root": true }
 */
const Col = stack(col);
Col.displayName = 'Stack.Col';
/**
 * Place between items to create a gap. This is equivalent to setting `margin-left: auto` on the
 * first item in the right group, but easier to componentize as a spacer element.
 *
 * @compose {}
 */
function Spacer() {
    return jsx("div", { "data-fpl-component": "", className: spacer });
}
Spacer.displayName = 'Stack.Spacer';
function stack(cls) {
    // eslint-disable-next-line react/display-name
    return forwardRef(({ fill: fill$1, gap = 0, wrap, align, justify, padding, className, style, ...props }, ref) => {
        return (jsx("div", { "data-fpl-component": "", ref: ref, className: clsx(cls, className, { [fill]: fill$1 }), style: {
                ...resolvePadding(padding),
                ...style,
                gap,
                [wrapVar]: wrap ? 'wrap' : 'nowrap',
                justifyContent: justify,
                alignItems: align,
            }, ...props }));
    });
}

export { Col, Row, Spacer };
//# sourceMappingURL=stack.js.map
